import { nextTick } from 'vue';

import { useIdentityStore } from '@/stores/identity';
import { useImpersonatorStore } from '@/stores/impersonator';
import { useTokenStore } from '@/stores/token';

// Backend error descriptions for an invalid/expired token. Other 401s
// (e.g. permission errors) must not trigger a refresh.
const TOKEN_ERROR_DESCRIPTIONS = new Set([
  'Authentication token missing or invalid.',
  'Authentication token invalid or expired.', // Deprecated
  'Token Expired.', // Deprecated
  'Invalid Token.', // Deprecated
]);

export function isTokenErrorDescription(description?: string): boolean {
  return typeof description === 'string' && TOKEN_ERROR_DESCRIPTIONS.has(description);
}

export function logout() {
  useTokenStore().clearToken();
  useIdentityStore().clearCurrentBrand();
  useIdentityStore().clearIdentity();
  useImpersonatorStore().clearImpersonatedUser();
  void nextTick(() => {
    window.location.assign('/logout');
  });
}

export async function attemptTokenRefresh() {
  const success = await useTokenStore().refreshToken();
  if (success) {
    return true;
  }
  logout();
  return false;
}
